import { tsrContractsClient } from '../tsrContractsClient';

export const notesClient = () => tsrContractsClient.patientNotesContract;
